import { Middleware } from '@reduxjs/toolkit'

import browserHistory from 'src/Router/browser-history'

import rootReducer from '../root-reducer'

type Reducer = ReturnType<typeof rootReducer>
const hasType = (action: unknown): action is { type: string } =>
  typeof action === 'object' &&
  action !== null &&
  'type' in action &&
  typeof (action as { type?: unknown }).type === 'string'

export const redirect: Middleware<unknown, Reducer> =
  () => (next) => (action: unknown) => {
    if (
      hasType(action) &&
      action.type.includes('redirectToRoute') &&
      'payload' in action
    ) {
      browserHistory.push((action as { payload: string }).payload)
    }

    return next(action)
  }
